// import {  gql } from '@apollo/client';
import Fragemets from '../fragments';
var commonStateQuery = function commonStateQuery(_root, variables, _ref) {
  var getCacheKey = _ref.getCacheKey,
    client = _ref.client;
  var id = getCacheKey({
    __typename: 'CommonState',
    id: 'sidebar'
  });
  var commonState = client.readFragment({
    fragment: Fragemets.toggleSidebar,
    id: id
  });
  return commonState; // Data returned from Mutation
};
export default {
  commonState: commonStateQuery
};